import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { getArticle } from "@/content/articles";
import { abs, articleHead } from "@/content/seo";
import cover from "@/assets/sylwia-praca-zespol.jpg.asset.json";

const article = getArticle("konflikt-ze-wspolnikiem");

export const Route = createFileRoute("/konflikt-ze-wspolnikiem")({
  head: () => articleHead(article, abs(cover.url)),
  component: () => <ArticleLayout article={article} />,
});
